<style scoped>
.content-wrapper {
  line-height: 32px;
  padding-top: 4px;
}
</style>

<template>

<div class="drag-handle full-width display-flex">
  <div v-if="!editing" class="flex-item">
    <div class="wordwrap content-wrapper">{{modelContent}}</div>
    <small class="wordwrap content-wrapper">{{modelFeedback}}</small>
  </div>
  <div class="flex-item" v-else>
    <mu-text-field v-model="modelContent" multi-line :rows="1" :rows-max="3" full-width :placeholder="$t('answer.title')"></mu-text-field>
    <mu-text-field v-model="modelFeedback" multi-line :rows="1" :rows-max="3" full-width :placeholder="$t('answer.feedback')"></mu-text-field>
  </div>
  <mu-button icon small @click.stop.prevent="editing = !editing" v-tooltip="$t('button.edit')" class="vertical-align-middle" v-if="!editing" color="primary">
    <mu-icon value="edit"></mu-icon>
  </mu-button>
  <mu-button icon small @click.stop.prevent="onActionEdit" v-tooltip="$t('button.confirm')" class="vertical-align-middle" v-if="editing" color="success">
    <mu-icon value="check"></mu-icon>
  </mu-button>
  <mu-button icon small @click.stop.prevent="onClickDelete" v-tooltip="$t('button.delete')" class="vertical-align-middle" color="red">
    <mu-icon value="delete"></mu-icon>
  </mu-button>
  <mu-dialog :title="$t('button.delete') + $t('space') + $t('answer.title')" max-width="100%" scrollable :esc-press-close="false" :overlay-close="false" :open.sync="flagDialogDelete">
    {{stringDelete}}
    <mu-button slot="actions" flat color="primary" @click="onActionCancelDelete"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
    <mu-button slot="actions" flat color="primary" @click="onActionDelete"><mu-icon value="check"></mu-icon> {{$t('prompt.confirm')}}</mu-button>
  </mu-dialog>
</div>

</template>

<script>
// Library
import axios from "axios";

export default {
  name: 'AnswerItem',
  props: {
    answer: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      // Flag
      flagDialogDelete: false, // Boolean variable for status of delete dialog

      // Model
      modelContent: this.answer.content, // Bind with content input
      modelFeedback: typeof this.answer.feedback === 'string' ? this.answer.feedback : '',

      timeout: null,
      editing: false,
    }
  },
  computed: {
    // Flag
    isContentEmpty() {
      if (this.modelContent === "") {
        return true;
      } else {
        return false;
      }
    },

    // String
    stringDelete() {
      return this.$t('prompt.deleteMsg', { name: this.modelContent });
    },
  },
  watch: {
    
  },
  methods: {
    // Event
    onActionEdit() {
      this.editing = false;
      axios.put(this.$store.getters.urlApi + "answer/" + this.answer._id, {
        'content': this.modelContent,
        'feedback': this.modelFeedback
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$emit("onUpdateAnswer");
      });
    },
    onClickDelete() {
      this.flagDialogDelete = true;
    },
    onActionDelete() {
      axios.delete(this.$store.getters.urlApi + "answer/" + this.answer._id, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(() => {
        this.$emit("onUpdateAnswer");
        this.$toast.success(this.$t('toast.delete'));
      });
    },
    onActionCancelDelete() {
      this.flagDialogDelete = false;
    },
  },

}
</script>
